import React from 'react';

type BadgeVariant = 'grade-aplus' | 'grade-a' | 'grade-b' | 'grade-c' | 'active' | 'on-leave' | 'inactive' | 'suspended' | 'scheduled' | 'duty-active' | 'completed' | 'cancelled' | 'default';

const variantClasses: Record<BadgeVariant, string> = {
  'grade-aplus': 'grade-aplus',
  'grade-a': 'grade-a',
  'grade-b': 'grade-b',
  'grade-c': 'grade-c',
  'active': 'status-active',
  'on-leave': 'status-on-leave',
  'inactive': 'status-inactive',
  'suspended': 'status-suspended',
  'scheduled': 'duty-scheduled',
  'duty-active': 'duty-active',
  'completed': 'duty-completed',
  'cancelled': 'duty-cancelled',
  'default': 'bg-muted text-muted-foreground',
};

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

export default function Badge({ variant = 'default', children, className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-600 tracking-wide ${variantClasses[variant]} ${className}`}
    >
      {children}
    </span>
  );
}

export function gradeVariant(grade: string): BadgeVariant {
  if (grade === 'A+') return 'grade-aplus';
  if (grade === 'A') return 'grade-a';
  if (grade === 'B') return 'grade-b';
  if (grade === 'C') return 'grade-c';
  return 'default';
}

export function crewStatusVariant(status: string): BadgeVariant {
  if (status === 'Active') return 'active';
  if (status === 'On Leave') return 'on-leave';
  if (status === 'Inactive') return 'inactive';
  if (status === 'Suspended') return 'suspended';
  return 'default';
}

export function dutyStatusVariant(status: string): BadgeVariant {
  if (status === 'Scheduled') return 'scheduled';
  if (status === 'Active') return 'duty-active';
  if (status === 'Completed') return 'completed';
  if (status === 'Cancelled') return 'cancelled';
  return 'default';
}